import { Check } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { SectionHeading } from "./SectionHeading";
import { Reveal } from "./Reveal";

const POINTS = [
  "Respect des plans et détails techniques",
  "Coordination avec les autres corps d’état",
  "Communication régulière",
  "Respect des jalons de planning",
  "Contrôle qualité avant réception",
  "Réactivité sur les ajustements chantier",
];

export const Professionnels = () => {
  const navigate = useNavigate();

  return (
  <section id="professionnels" data-testid="professionnels-section" className="bg-nuit py-24 lg:py-32">
    <div className="mx-auto max-w-7xl px-6 lg:px-10 grid lg:grid-cols-2 gap-16 lg:gap-24">
      <div>
        <SectionHeading
          chapter="04 — Professionnels"
          title="Un partenaire d’exécution fiable"
          subtitle="Pour les architectes et maîtres d’œuvre qui recherchent une entreprise structurée et attentive aux détails."
          dark
          testId="professionnels"
        />
        <Reveal delay={0.1}>
          <p className="text-base leading-relaxed text-casse/75 max-w-xl" data-testid="professionnels-text">
            Nous savons qu’une entreprise intervenant sur vos projets engage aussi votre réputation.
            Notre objectif est simple : exécuter correctement, communiquer clairement et limiter les réserves.
          </p>
          <a
            href="/architectes-maitres-oeuvre"
            data-testid="professionnels-cta"
            onClick={(e) => { e.preventDefault(); navigate("/architectes-maitres-oeuvre"); }}
            className="mt-10 inline-block bg-sable px-8 py-4 font-accent text-sm font-medium tracking-[0.12em] uppercase text-nuit hover:bg-casse transition-colors duration-300"
          >
            Présenter un projet
          </a>
        </Reveal>
      </div>
      <div className="flex flex-col justify-center">
        {POINTS.map((p, i) => (
          <Reveal key={p} delay={i * 0.06}>
            <div
              data-testid={`pro-point-${i + 1}`}
              className="flex items-center gap-5 border-b border-casse/10 py-5 first:border-t"
            >
              <span className="flex h-8 w-8 shrink-0 items-center justify-center border border-sable/40 text-sable">
                <Check size={15} strokeWidth={1.75} />
              </span>
              <span className="font-accent text-sm md:text-base font-medium tracking-wide text-casse/90">{p}</span>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
  );
};
